<template>
  <div class="container">
    <img class="wange" src="../../assets/images/wange.jpg" />
    <div class="body">
        <h2 class="topSpan">高级实名</h2>
        <p class="messageSpan">添加您的人脸信息，使用人脸识别快捷出入办公区域，开门更简单</p>
        <div class="imageBg">
          <img v-if="imageUrl" class="paiIcon" :src='imageUrl'/>
          <!-- <img v-else-if="loaclImg" class="paiIcon"  :src='loaclImg' /> -->
          <img v-else class="paiIcon" src='../../assets/images/icon_addphoen.jpg'/>
          <span v-if="imageUrl &&isUpImging==false" @click="chooseImg" class="reup_span" >重新拍摄</span>
          <!-- <div v-show="imageUrl &&isUpImging==false" class="item_center_inp" style="opacity:0;">
              <upload-img id="uploadImg1" @uploadImg="uploadImg" @changeloaclImg='changeloaclImg' :upURL="upURL"></upload-img>
          </div> -->
        </div>
        <span class="bottomMessage" >请拍照上传本人清晰正面照</span>
        <img class="photo" src="../../assets/images/photo.png" />
        <!-- <span v-if="imageUrl" class="dopostPhone_span" @click="saveUserFace" >完成上传</span> -->
        <span v-if="$route.query.come != 'edit'" class="tiaoguo" @click="goBack">跳过</span>
    </div>
    <footer class="footer button">
      <p class="btn_bm" v-if="isShowBackUserFace" style="margin-bottom: 10px;" @click="backUserFace">撤回授权</p>
      <p class="btn_bm" @click="saveUserFace">{{!(imageUrl && isUpImging==false)?'开始拍摄':'提交'}}</p>
      <!-- <div v-show="!(imageUrl &&isUpImging==false)" class="item_center_inp" style="opacity:0;">
        <upload-img @uploadImg="uploadImg" @changeloaclImg='changeloaclImg' :upURL="upURL"></upload-img>
      </div> -->
    </footer>
    <div class="mask_wrap"  v-if="isShowCollectInfo">
      <div class="mask_content">
        <p class="info_wrap">我们需要收集您的人脸信息用于身份识别，以便您能便捷通行。我们保证不会将您的人脸信息用于任何其他用途，同时，我们会采取有效的信息安全措施保证您的信息安全。若您不同意我们收集您的人脸信息，您可选择刷码等其他方式进行身份验证。</p>
        <div class="btn_wrap">
          <div @click="noAgreeCollectInfo">暂不使用</div>
          <div @click="agreeCollectInfo">同意并继续</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import uploadImg from '../../components/uploadImg'
import { serversHttp,saveUserFace,uploadWapFace,delUserFace} from '../../utils/api.js'
import util from "../../utils/util"
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
import storage from '@/utils/storage'

export default {
  name: "addPhoto",
  components: {
    uploadImg
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      upURL:serversHttp+"servers.api/fileApi/uploadFace",
      loaclImg:'',
      backIndex:-1,
      imageUrl:'',
      ShareInfo:"",
      isUpImging:false,
      isShowBackUserFace:false,//是否显示撤回授权按钮
      isShowCollectInfo:false,//是否显示授权弹窗
      isAgreeCollectInfo:false//是否同意授权
    };
  },
  created(){
    console.log('是否授权');
  },
  mounted(){
    console.log(this.$route.query.authorize,'是否授权');
    if(this.$route.query.authorize==1){//已有头像
      this.isShowBackUserFace=true;
      this.isShowCollectInfo = false
      this.isAgreeCollectInfo = true
    }else{
      this.isShowBackUserFace=false;
      this.isShowCollectInfo = true
      this.isAgreeCollectInfo = false
    }

 
  },

  methods:{
      goBack(){
        this.$router.go(-1);
      },
      changeloaclImg(val){
          this.loaclImg=val;
          this.isUpImging=true;
          setTimeout(() => this.isUpImging=false, 7*1000)
      },
      uploadImg(val){
        console.log(val)
        this.isUpImging = false;
        if(val.isValid){
            this.imageUrl = val.imgUrl
            console.log(this.imageUrl)
        }else{
            util.showToast(val.errMsg)
        }
      },
      noAgreeCollectInfo(){
        this.isShowCollectInfo = false
        this.isAgreeCollectInfo = false
      },
      //同意
      agreeCollectInfo(){
        this.isShowCollectInfo = false
        this.isAgreeCollectInfo = true
      },
      saveUserFace(){
        if(!this.isAgreeCollectInfo){
          util.showToast('请先同意授权')
          this.isShowCollectInfo = true
          return
        }
 
        if(!this.imageUrl){
          this.chooseImg();
        }else{
          util.showLoading();
          saveUserFace({
            userId: this.common.userId,
            faceImgUrl:this.imageUrl
          }).then(res => {
            util.hideLoading();
            if (res.res && res.res.code === 10000) {
                this.goBack();
            } else {
              util.showToast(res.res.msg);
            }
          });
        }
      },
      chooseImg(){
        console.log('chufa');
        let that = this;
        wx.ready(()=>{
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
              console.log(res)
              wx.uploadImage({
                localId: res.localIds[0],
                isShowProgressTips: 1,
                success: function (ret) {
                  // 返回图片的服务器端ID
                  var serverId = ret.serverId;
                  that.uploadWapFace(serverId)
                }
              })
            },
            fail: function (res){
              alert(JSON.stringify(res))
            }
          })
        })
      },
    uploadWapFace(id){
      let params = {
        mediaId:id,
        marketId:this.common.marketInfo.id
      }
      util.showLoading();
      uploadWapFace(params).then(res=>{
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body){
          util.hideLoading()
          if(res.body.isValid){
            this.imageUrl = res.body.imgUrl
          }else{
            util.showToast(res.body.errMsg)
          }
        }else{
          util.showToast('图片上传失败')
          util.hideLoading()
        }
      })
    },
    backUserFace(){
      util.showModal('授权提醒','您将撤回对人脸信息的授权，后续需使用刷码、实体卡等方式通行。', true, '确定', () => {
        this.deleteFace()
      })
    },
    deleteFace(){
      delUserFace({
        userId: this.common.userId,
        delFace:'1'
      }).then(res =>{
        console.log(res);
        if(res.res.code == 10000){
          this.isShowBackUserFace = false
          this.isAgreeCollectInfo = false
          this.imageUrl = ''
        }else{
          util.showToast(res.res.msg)
        }
        
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
  width:100%;
  height:100%;
  background:rgba(255,255,255,1);
  position: relative;
}
.wange{
  width:100%;
  margin-top:60px;
}
.body{
    flex-direction: column;
    display: flex;
    align-items: center;
    position: absolute;
    top:0;
    width:100%;
    overflow:hidden;
}
.topSpan{
    margin-top: 80px;
    height:66px;
    font-size:48px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:66px;
    text-align: center;
}
.messageSpan{
    width:564px;
    margin-top: 20px;
    font-size:28px;
    font-weight:400;
    color:#666;
    line-height:40px;
    text-align: center;
}
.imageBg{
  margin-top:40px;
  width:280px;
  height:280px;
  padding:20px;
  box-sizing:border-box;
  position:relative;
  box-shadow:0px 4px 40px 0px rgba(0,91,165,0.29);
  border-radius:8px;
  overflow:hidden;
  background:#fff;
  z-index:3;
}
.paiIcon{
    width:240px;
    height:240px;
}
.item_center_inp {
    position: absolute;left:0;right:0;top:0;bottom:0;
    z-index: 999;
}
.phone{
    position: absolute;
    width: 44px;
    height: 44px;
    top:50%;left:50%;
    transform: translate(-50%,-50%);
}
.reup_span{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width:240px;
    height:52px;
    font-size:24px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:52px;
    text-align: center;
    z-index: 100;
    background:rgba(0,0,0,0.5);
}
.bottomMessage{
    margin-top: 28px;
    height:40px;
    font-size:28px;
    color:#FD9838;
    line-height:40px;
    text-align: center;
}
.dopostPhone_span{
    // margin-left: 28px;
    margin-top: 40px;
    width:694px;
    height:76px;
    background:rgba(23,64,218,1);
    border-radius:4px;
    text-align: center;
    font-size:32px;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:76px;
}

.bottomButton{
    position: absolute;
    bottom: 60px;
    left: 344px;
    height:44px;
    font-size:32px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:44px;
}
.photo{
  width:462px;
  margin-top:102px;
}
.tiaoguo{
  position: absolute;
  top:28px;right:28px;
  width:120px;
  height:56px;
  line-height:56px;
  text-align:center;
  background:rgba(248,248,248,1);
  border-radius:28px;
  color:#1740DA;
  font-size:28px;
}
.footer{
  position:fixed;
  bottom:0;right:0;left:0;
  // height:144px;
  padding:28px;
  box-sizing: border-box;
  p{
    height:88px;
    background:rgba(23,64,218,1);
    border-radius:8px;
    line-height:88px;
    text-align:center;
    color:#fff;
    font-size:34px;
  }
}
.mask_wrap{
  position:fixed;
  top:0;
  left:0;    
  width: 100%;
  height: 100vh;
  background: rgba(174,171,171,.5);
  z-index: 999;
  .mask_content{
    width: 480px;
    height: 386px;
    padding: auto;
    background: #fff;
    color: #000;
    border-radius: 8px;
    position: relative;
    top:50%;
    left:50%;    
    transform: translate(-50%,-50%);
    display: flex;
    flex-direction: column;
    .info_wrap{
      width: 100%;
      flex: 1;
      padding: 24px 24px 0;
      text-indent: 24px;
      box-sizing: border-box;
      font-size: 28px;
      line-height: 34px;
    }
    .btn_wrap{
      height: 88px;
      border-top:1px solid #ccc;
      display: flex;
      flex-direction: row;
      div{
        flex: 1;
        font-size: 32px;
        line-height: 88px;
        text-align: center;
        &:first-child{
          border-right:1px solid #ccc;
          color: #333333;
        }
        &:last-child{
          color: #1740DA;
        }
 
      }
    }
  }
}
</style>
